/*
  Pre-order dates in the customer's browser (Europe/Belgrade).
  Liquid's "now" can be cached, so today's date and the "ships until" check happen here, once.
  Variant changes need nothing from this file: the CSS reacts to #Preorder-* being re-rendered.
*/
(() => {
  const config = document.querySelector('[data-hbb-preorder-config]');
  if (!config) return;

  let data;
  try {
    data = JSON.parse(config.textContent);
  } catch (error) {
    return;
  }

  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone: 'Europe/Belgrade',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).formatToParts(new Date());
  const part = (type) => parts.find((p) => p.type === type).value;
  const todayIso = `${part('year')}-${part('month')}-${part('day')}`;

  if (!/^\d{4}-\d{2}-\d{2}$/.test(data.until || '') || todayIso > data.until) {
    document.documentElement.classList.add('hbb-preorder-expired');
  }

  const todayLabel = `${Number(part('day'))} ${data.months[Number(part('month')) - 1]}`;
  document.querySelectorAll('[data-hbb-today]').forEach((el) => {
    el.textContent = todayLabel;
  });
})();
